import { render, staticRenderFns } from "./SpousePartnerLoginAssistance.vue?vue&type=template&id=31431b2a&scoped=true&"
import script from "./SpousePartnerLoginAssistance.vue?vue&type=script&lang=js&"
export * from "./SpousePartnerLoginAssistance.vue?vue&type=script&lang=js&"
import style0 from "./SpousePartnerLoginAssistance.vue?vue&type=style&index=0&id=31431b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31431b2a",
  null
  
)

export default component.exports